import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';

export async function ensureUserProfile(user) {
  if (!user) return;
  const ref = doc(db, 'users', user.uid);
  const payload = {
    email: user.email || null,
    displayName: user.displayName || null,
  };
  await setDoc(ref, payload, { merge: true });
}

